<script setup>
import {LinkIcon} from "@heroicons/vue/16/solid";
import OverlayComponent from "@/components/OverlayComponent.vue";

const props = defineProps({
  title: {
    default: null,
    type: String
  },
  subtitle: {
    default: null,
    type: String
  },
  description: {
    default: null,
    type: String
  },
})
</script>

<template>
  <div class="container mx-auto px-2 py-10 text-left relative z-20">
    <h1
      v-if="props.subtitle"
      class="h1 text-gray-100 text-2xl md:text-4xl pt-5 md:p-10 font-semibold drop-shadow-sm"
    >
      <a :href="`/${props.subtitle}`">
        <span class="text-green-500">{{ props.subtitle }}</span>
      </a>
      <span> - </span>
      <a
        v-if="props.title"
        :href="``"
        class="text-gray-100"
      >
        {{ props.title }}
        <LinkIcon class="h-6 w-6 text-gray-300 inline" />
      </a>
    </h1>
    <div
      v-if="props.description"
      class="text-gray-100 font-medium py-4 px-10 drop-shadow-sm"
      v-html="props.description"
    />
  </div>
  <OverlayComponent />
</template>

<style scoped>

</style>
